/* ==========================================================================
   Raspberry Lychee LE — landing page behaviour
   Owner: Katie Spaller.  ChangeSet: CS-2026-256.  Spec v1.1.

   No jQuery. No lazysizes. No third-party anything.
   Note: cw-layout.liquid loads jQuery globally and the reused USPA slider
   uses Slick, so jQuery IS on the page — this file just doesn't touch it.

   Per-instance init via data attributes. Every existing subscription section
   in this theme breaks if placed twice on a page because they use
   getElementById or a first-match querySelector. This does not.
   ========================================================================== */
(function () {
  'use strict';

  var MODE_ONCE = 'onetime';
  var MODE_SUB  = 'subscribe';

  /* Shopify money format, e.g. "${{amount}}" — read off the section so we
     never hardcode a currency symbol. */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return '$' + withCommas;
    if (format.indexOf('amount_no_decimals') > -1) {
      withCommas = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g, withCommas);
  }

  function initShop(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var threshold   = parseInt(root.getAttribute('data-threshold'), 10);

    var form        = root.querySelector('[data-rl-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-rl-variant-input]');
    var packs        = Array.prototype.slice.call(form.querySelectorAll('[data-rl-pack]'));
    var modes        = Array.prototype.slice.call(form.querySelectorAll('[data-rl-mode]'));
    var subCard      = root.querySelector('[data-rl-sub-card]');
    var freqWrap     = root.querySelector('[data-rl-freq]');
    var planSelect   = root.querySelector('[data-rl-plan-select]');
    var qtyInput     = form.querySelector('[data-rl-qty]');
    var qtyDown      = form.querySelector('[data-rl-qty-down]');
    var qtyUp        = form.querySelector('[data-rl-qty-up]');
    var totalEl      = form.querySelector('[data-rl-total]');
    var addBtn       = form.querySelector('[data-rl-add]');
    var addLabel     = form.querySelector('[data-rl-add-label]');
    var errorEl      = form.querySelector('[data-rl-error]');
    var shipEl       = form.querySelector('[data-rl-ship]');
    var oncePriceEl  = root.querySelector('[data-rl-once-price]');
    var oncePerCanEl = root.querySelector('[data-rl-once-percan]');
    var subPerCanEl  = root.querySelector('[data-rl-sub-percan]');
    var subPriceEl   = root.querySelector('[data-rl-sub-price]');
    var subCompareEl = root.querySelector('[data-rl-sub-compare]');
    var subSaveEl    = root.querySelector('[data-rl-sub-save]');
    var planData     = {};
    var planScript   = root.querySelector('[data-rl-plans]');
    if (planScript) {
      try { planData = JSON.parse(planScript.textContent) || {}; }
      catch (e) { planData = {}; }
    }
    var sticky       = root.querySelector('[data-rl-sticky]');
    var stickyPrice  = root.querySelector('[data-rl-sticky-price]');
    var stickyAdd    = root.querySelector('[data-rl-sticky-add]');
    var baseAddText  = addLabel ? addLabel.textContent.trim() : 'Add to cart';

    var shipUnder = root.getAttribute('data-ship-under') || '';
    var shipOver  = root.getAttribute('data-ship-over') || '';
    var perCanSuffix = root.getAttribute('data-percan-suffix') || '';

    /* Per-can figure, computed from the selected pack's live price divided by
       its can count. Never hardcoded: at current pricing this yields $4.99
       one-time and $3.99 on subscription, and it stays correct if either the
       pack price or the subscription discount changes. */
    function perCan(cents, cans) {
      if (!cans || cans < 1 || !cents) return '';
      return formatMoney(Math.round(cents / cans), moneyFormat) +
             (perCanSuffix ? ' ' + perCanSuffix : '');
    }

    function selectedPack() {
      for (var i = 0; i < packs.length; i++) { if (packs[i].checked) return packs[i]; }
      return packs[0] || null;
    }

    function currentMode() {
      for (var i = 0; i < modes.length; i++) { if (modes[i].checked) return modes[i].value; }
      return MODE_ONCE;
    }

    function qty() {
      var n = parseInt(qtyInput ? qtyInput.value : '1', 10);
      if (isNaN(n) || n < 1) n = 1;
      var max = qtyInput ? parseInt(qtyInput.getAttribute('max'), 10) : NaN;
      if (!isNaN(max) && n > max) n = max;
      return n;
    }

    /* Unit price for the current pack + mode. Subscription price comes from
       the selected plan option when one exists, so switching frequency
       recalculates correctly. */
    function unitPrice() {
      var pack = selectedPack();
      if (!pack) return 0;
      var once = parseInt(pack.getAttribute('data-price'), 10) || 0;
      if (currentMode() !== MODE_SUB) return once;

      if (planSelect && !planSelect.disabled && planSelect.selectedIndex > -1) {
        var opt = planSelect.options[planSelect.selectedIndex];
        var p = parseInt(opt.getAttribute('data-price'), 10);
        if (!isNaN(p) && p > 0) return p;
      }
      var sub = parseInt(pack.getAttribute('data-sub-price'), 10) || 0;
      return sub > 0 ? sub : once;
    }

    function packHasPlans(pack) {
      return pack ? (parseInt(pack.getAttribute('data-plan-count'), 10) || 0) > 0 : false;
    }

    /* Rebuild the frequency <select> for the selected variant. Without this the
       option labels keep the previous pack's plan prices. Preserves the
       shopper's chosen cadence across pack switches when the same plan exists. */
    var lastPackId = null;
    function syncPlanOptions(pack) {
      if (!planSelect || !pack) return;
      if (lastPackId === pack.value) return;

      var plans = planData[pack.value];
      if (!plans || !plans.length) { lastPackId = pack.value; return; }

      var previouslyChosen = planSelect.value;
      var defaultMatch = planSelect.getAttribute('data-default-match') || '';

      planSelect.innerHTML = '';
      var toSelect = null;
      plans.forEach(function (plan) {
        var opt = document.createElement('option');
        opt.value = plan.id;
        opt.setAttribute('data-price', plan.price);
        opt.textContent = plan.label || plan.name;
        planSelect.appendChild(opt);
        if (String(plan.id) === String(previouslyChosen)) toSelect = String(plan.id);
        if (toSelect === null && defaultMatch && plan.name.indexOf(defaultMatch) > -1) {
          toSelect = String(plan.id);
        }
      });
      planSelect.value = toSelect !== null ? toSelect : String(plans[0].id);
      lastPackId = pack.value;
    }

    function render() {
      var pack = selectedPack();
      if (!pack) return;

      if (variantInput) variantInput.value = pack.value;
      syncPlanOptions(pack);

      var once = parseInt(pack.getAttribute('data-price'), 10) || 0;
      var sub  = parseInt(pack.getAttribute('data-sub-price'), 10) || 0;
      var hasPlans = packHasPlans(pack);
      var mode = currentMode();

      /* Availability-driven: a pack with no selling plans (the 6-pack, or any
         pack before Friday's Recharge attach) gets no subscribe path at all.
         Force back to one-time so we can never post a plan that isn't valid
         for the selected variant. */
      if (subCard) {
        if (hasPlans) {
          subCard.hidden = false;
        } else {
          subCard.hidden = true;
          var subInput = subCard.querySelector('[data-rl-mode="subscribe"]');
          if (subInput && subInput.checked) {
            var onceInput = form.querySelector('[data-rl-mode="onetime"]');
            if (onceInput) { onceInput.checked = true; }
            mode = MODE_ONCE;
          }
        }
      }

      /* The plan select must be disabled when not subscribing, otherwise a
         selling_plan posts alongside a one-time purchase. */
      if (planSelect) {
        var subActive = (mode === MODE_SUB) && hasPlans;
        planSelect.disabled = !subActive;
        if (freqWrap) freqWrap.hidden = !subActive;
      }

      if (oncePriceEl)  oncePriceEl.textContent = formatMoney(once, moneyFormat);
      if (subPriceEl)   subPriceEl.textContent  = formatMoney(sub > 0 ? sub : once, moneyFormat);

      var cans = parseInt(pack.getAttribute('data-cans'), 10) || 0;
      if (oncePerCanEl) oncePerCanEl.textContent = perCanSuffix ? perCan(once, cans) : '';
      if (subPerCanEl)  subPerCanEl.textContent  = perCanSuffix ? perCan(sub > 0 ? sub : once, cans) : '';

      if (subCompareEl) {
        var showCompare = sub > 0 && sub < once;
        subCompareEl.style.display = showCompare ? '' : 'none';
        if (showCompare) subCompareEl.textContent = formatMoney(once, moneyFormat);
      }
      if (subSaveEl) {
        if (sub > 0 && sub < once) {
          subSaveEl.textContent = 'Save ' + Math.round(((once - sub) / once) * 100) + '%';
        } else {
          subSaveEl.textContent = '';
        }
      }

      var total = unitPrice() * qty();
      var totalText = formatMoney(total, moneyFormat);
      if (totalEl)     totalEl.textContent = totalText;
      if (stickyPrice) stickyPrice.textContent = totalText;

      /* CTA label states what it does. A bare "Add to cart" on a subscription
         is how "did not mean to start a subscription" becomes a cancel reason. */
      if (addLabel) {
        addLabel.textContent = (mode === MODE_SUB)
          ? 'Subscribe · ' + totalText
          : baseAddText + ' · ' + totalText;
      }

      /* Free-shipping note computed from the LIVE adjusted price. The 24-pack
         at 20% off lands under $100, so a naive one-time-only calculation
         would show a false claim on the subscribe path. */
      if (shipEl && !isNaN(threshold) && threshold > 0) {
        if (total >= threshold) {
          if (shipOver) { shipEl.innerHTML = shipOver; shipEl.hidden = false; }
          else { shipEl.hidden = true; }
        } else if (shipUnder) {
          shipEl.innerHTML = shipUnder.replace('[amount]', '<strong>' + formatMoney(threshold - total, moneyFormat) + '</strong>');
          shipEl.hidden = false;
        } else {
          shipEl.hidden = true;
        }
      }
    }

    function showError(msg) {
      if (!errorEl) { window.alert(msg); return; }
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }

    function setBusy(on) {
      [addBtn, stickyAdd].forEach(function (b) {
        if (!b) return;
        b.setAttribute('aria-busy', on ? 'true' : 'false');
        if (on) { b.setAttribute('aria-disabled', 'true'); }
        else { b.removeAttribute('aria-disabled'); }
      });
    }

    function addToCart() {
      clearError();
      var pack = selectedPack();
      if (!pack) return;

      var body = { id: parseInt(pack.value, 10), quantity: qty() };
      if (currentMode() === MODE_SUB && planSelect && !planSelect.disabled && planSelect.value) {
        body.selling_plan = parseInt(planSelect.value, 10);
      }

      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [body] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); }
          else { window.location.href = '/cart'; }
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Could not add to cart. Please try again.');
        })
        .then(function () { setBusy(false); });
    }

    /* ---- listeners ---- */

    packs.forEach(function (p) { p.addEventListener('change', render); });
    modes.forEach(function (m) { m.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', render);
    if (qtyInput)   qtyInput.addEventListener('input', render);

    if (qtyDown) qtyDown.addEventListener('click', function () {
      qtyInput.value = Math.max(1, qty() - 1); render();
    });
    if (qtyUp) qtyUp.addEventListener('click', function () {
      var max = parseInt(qtyInput.getAttribute('max'), 10);
      var next = qty() + 1;
      qtyInput.value = isNaN(max) ? next : Math.min(max, next);
      render();
    });

    /* Progressive enhancement: the form posts natively without JS. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
    if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

    /* ---- Gallery carousel ----
       Scroll-snap strip, no slider library. Arrows are shown only when the
       row actually overflows, so a two-image product does not get dead
       controls. Left/Right arrow keys move between thumbs. */
    var mainWrap = root.querySelector('[data-rl-gallery-main]');
    var mainImg  = root.querySelector('[data-rl-gallery-img]');
    var strip    = root.querySelector('[data-rl-thumb-strip]');
    var prevBtn  = root.querySelector('[data-rl-thumb-prev]');
    var nextBtn  = root.querySelector('[data-rl-thumb-next]');
    var thumbs   = Array.prototype.slice.call(root.querySelectorAll('[data-rl-thumb]'));

    function selectThumb(t) {
      var full = t.getAttribute('data-full');
      if (!full || !mainImg) return;
      thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      if (mainWrap) mainWrap.classList.add('is-swapping');
      var srcset = t.getAttribute('data-full-srcset');
      var pre = new Image();
      pre.onload = function () {
        if (srcset) { mainImg.srcset = srcset; } else { mainImg.removeAttribute('srcset'); }
        mainImg.src = full;
        if (mainWrap) mainWrap.classList.remove('is-swapping');
      };
      pre.onerror = function () { if (mainWrap) mainWrap.classList.remove('is-swapping'); };
      pre.src = full;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectThumb(t); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = thumbs[i + 1];
        else if (e.key === 'ArrowLeft') next = thumbs[i - 1];
        else return;
        e.preventDefault();
        if (next) { next.focus(); selectThumb(next); }
      });
    });

    function stripStep() {
      if (!strip) return 0;
      var first = strip.querySelector('li');
      var w = first ? first.getBoundingClientRect().width : 88;
      return Math.max(w + 8, Math.round(strip.clientWidth * 0.8));
    }
    function syncArrows() {
      if (!strip || !prevBtn || !nextBtn) return;
      var overflowing = strip.scrollWidth > strip.clientWidth + 4;
      if (!overflowing) {
        prevBtn.hidden = true; nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = strip.scrollLeft <= 2;
      nextBtn.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
    }
    if (strip) {
      if (prevBtn) prevBtn.addEventListener('click', function () {
        strip.scrollBy({ left: -stripStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        strip.scrollBy({ left: stripStep(), behavior: 'smooth' });
      });
      strip.addEventListener('scroll', syncArrows, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(syncArrows).observe(strip);
      } else {
        window.addEventListener('resize', syncArrows);
      }
      syncArrows();
    }

    /* Sticky mobile ATC — appears once the total row scrolls out of view. */
    if (sticky && totalEl && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      io.observe(totalEl);
    }

    render();
  }

  /* ---- You may also like: per-card variant resolution + add to cart ----
     Replaces the jQuery handlers in cw-custom-dev.js that key off
     .js_parent--box, which collide when more than one grid is on a page.
     Hidden variants are absent from the lookup table, so they cannot be
     resolved or posted. */
  function initCrossCard(card) {
    var form    = card.querySelector('[data-rl-cross-form]');
    if (!form) return;
    var dataEl  = card.querySelector('[data-rl-cross-variants]');
    var idInput = card.querySelector('[data-rl-cross-variant]');
    var priceEl = card.querySelector('[data-rl-cross-price]');
    var addBtn  = card.querySelector('[data-rl-cross-add]');
    var addLbl  = card.querySelector('[data-rl-cross-add-label]');
    var errEl   = card.querySelector('[data-rl-cross-error]');
    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-rl-cross-option]'));
    var baseLbl = addLbl ? addLbl.textContent.trim() : 'Add to cart';
    var moneyFormat = '${{amount}}';
    var shop = document.querySelector('[data-ks-rl-shop]');
    if (shop) moneyFormat = shop.getAttribute('data-money-format') || moneyFormat;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }

    function resolve() {
      var picked = selects.map(function (sel) { return sel.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var vals = [v.o1, v.o2, v.o3];
        var match = true;
        for (var j = 0; j < picked.length; j++) {
          if (String(vals[j] || '') !== String(picked[j] || '')) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render() {
      var v = selects.length ? resolve() : variants[0];
      if (!v) {
        if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); }
        if (addLbl) { addLbl.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('aria-disabled'); }
        else { addBtn.setAttribute('aria-disabled', 'true'); }
      }
      if (addLbl) addLbl.textContent = v.available ? baseLbl : 'Sold out';
    }

    selects.forEach(function (sel) { sel.addEventListener('change', render); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var v = selects.length ? resolve() : variants[0];
      if (!v || !v.available) return;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
            return d;
          });
        })
        .then(function () {
          if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); }
          else { window.location.href = '/cart'; }
        })
        .catch(function (err) {
          if (errEl) { errEl.textContent = err && err.message ? err.message : 'Could not add to cart.'; errEl.hidden = false; }
        })
        .then(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
    });

    render();
  }

  function boot() {
    var shops = document.querySelectorAll('[data-ks-rl-shop]');
    for (var i = 0; i < shops.length; i++) {
      if (shops[i].getAttribute('data-rl-ready') === 'true') continue;
      shops[i].setAttribute('data-rl-ready', 'true');
      initShop(shops[i]);
    }

    var cards = document.querySelectorAll('[data-rl-cross-card]');
    for (var c = 0; c < cards.length; c++) {
      if (cards[c].getAttribute('data-rl-ready') === 'true') continue;
      cards[c].setAttribute('data-rl-ready', 'true');
      initCrossCard(cards[c]);
    }

    /* Give the first instance the bare anchor id so #ks-rl-shop always
       resolves and is never duplicated. */
    var first = document.querySelector('[data-ks-rl-anchor="ks-rl-shop"]');
    if (first && !document.getElementById('ks-rl-shop')) { first.id = 'ks-rl-shop'; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();
